/* Seamless loop: two staggered copies of the clip crossfade across the loop
   seam, so the jump from last frame to first frame is never visible.
   Both run at half speed for a calm, suspended pace. */
(function(){
  const a = document.getElementById('puffVideo');
  const b = document.getElementById('puffVideo2');
  if(!a || !b) return;

  const RATE = 0.5;     // half speed
  const FADE = 1.2;     // real seconds of crossfade across the seam

  [a,b].forEach(v=>{ v.loop = false; v.muted = true; v.playbackRate = RATE; });

  let active = a, idle = b;
  a.style.opacity = '1';
  b.style.opacity = '0';

  function tick(){
    const v = active;
    if(v.duration && !isNaN(v.duration)){
      const remain = (v.duration - v.currentTime) / RATE;   // real seconds left

      if(remain <= FADE){
        if(idle.paused){
          idle.currentTime = 0;
          idle.playbackRate = RATE;
          idle.play().catch(()=>{});
        }
        const k = Math.max(0, Math.min(1, remain / FADE)); // 1 -> 0
        active.style.opacity = k.toFixed(3);
        idle.style.opacity   = (1 - k).toFixed(3);
      }

      if(v.currentTime >= v.duration - 0.03 || v.ended){
        active.style.opacity = '0';
        idle.style.opacity   = '1';
        v.pause();
        const tmp = active; active = idle; idle = tmp;
      }
    }
    requestAnimationFrame(tick);
  }

  function begin(){
    a.playbackRate = RATE;
    a.play().catch(()=>{});
    requestAnimationFrame(tick);
  }
  if(a.readyState >= 1) begin();
  else a.addEventListener('loadedmetadata', begin, { once:true });
})();
(function(){
  const stage   = document.getElementById('stage');
  const svg     = document.getElementById('threads');
  const puffEl  = document.getElementById('puffWrap');
  const labels  = [...document.querySelectorAll('.label')];

  const SVGNS = "http://www.w3.org/2000/svg";

  // Build one path + one terminal dot per label.
  // The path is a smooth cubic Bezier from the label's edge to a target near the puff core,
  // with a soft control point that gives it a "thread tension" curve.
  const lines = new Map();   // id -> {path, dot, side}

  function buildLines(){
    svg.innerHTML = '';
    labels.forEach(lab=>{
      const id   = lab.dataset.id;
      const side = lab.dataset.side;

      const path = document.createElementNS(SVGNS,'path');
      path.classList.add('thread-line');
      path.setAttribute('data-id', id);
      svg.appendChild(path);

      lines.set(id, {path, side});
    });
  }

  function rectInStage(el){
    const sb = stage.getBoundingClientRect();
    const r  = el.getBoundingClientRect();
    return {
      left:   r.left   - sb.left,
      right:  r.right  - sb.left,
      top:    r.top    - sb.top,
      bottom: r.bottom - sb.top,
      cx:     r.left + r.width/2  - sb.left,
      cy:     r.top  + r.height/2 - sb.top,
      w:      r.width,
      h:      r.height
    };
  }

  // Compute thread geometry for one label, return path d-string and end point.
  function computeThread(lab){
    const lr = rectInStage(lab);
    const pr = rectInStage(puffEl);
    const side = lab.dataset.side;

    // start: the inner edge of the label
    const sx = side === 'left' ? lr.right - 4 : lr.left + 4;
    const sy = lr.cy;

    // target: a point on an inner ring around the puff core,
    // angle determined by the label's vertical position so threads fan naturally.
    const cx = pr.cx;
    const cy = pr.cy;
    const ringR = Math.min(pr.w, pr.h) * 0.22;
    const angle = Math.atan2(sy - cy, sx - cx);
    const ex = cx + Math.cos(angle) * ringR;
    const ey = cy + Math.sin(angle) * ringR;

    // catenary-like sag: a thread under its own weight, not a routed schematic
    const dx = ex - sx;
    const dy = ey - sy;
    const dist = Math.hypot(dx, dy);
    // sag scales with thread length, more pronounced for upper labels
    const sagAmount = dist * 0.10 + 14;

    // two control points biased downward (gravity) and slightly inward
    const c1x = sx + dx * 0.30;
    const c1y = sy + dy * 0.20 + sagAmount;
    const c2x = sx + dx * 0.70;
    const c2y = sy + dy * 0.65 + sagAmount * 0.6;

    const d = `M ${sx.toFixed(2)} ${sy.toFixed(2)} C ${c1x.toFixed(2)} ${c1y.toFixed(2)}, ${c2x.toFixed(2)} ${c2y.toFixed(2)}, ${ex.toFixed(2)} ${ey.toFixed(2)}`;
    return {d, ex, ey};
  }

  function refreshAll(){
    labels.forEach(lab=>{
      const ln = lines.get(lab.dataset.id);
      if(!ln) return;
      const {d} = computeThread(lab);
      ln.path.setAttribute('d', d);

      // set dasharray to the path length so we can reveal it
      const len = ln.path.getTotalLength();
      ln.path.style.strokeDasharray  = len;
      // keep dashoffset state in sync with active class
      if(!ln.path.classList.contains('active')){
        ln.path.style.strokeDashoffset = len;
      }else{
        ln.path.style.strokeDashoffset = 0;
      }
    });
  }

  function activate(id, on){
    const ln = lines.get(id);
    if(!ln) return;
    if(on){
      // make sure dasharray is set before animating offset to 0
      const len = ln.path.getTotalLength();
      ln.path.style.strokeDasharray  = len;
      ln.path.style.strokeDashoffset = len;
      // force reflow so transition fires
      // eslint-disable-next-line no-unused-expressions
      ln.path.getBoundingClientRect();
      ln.path.classList.add('active');
      ln.path.style.strokeDashoffset = 0;
    }else{
      const len = ln.path.getTotalLength();
      ln.path.classList.remove('active');
      ln.path.style.strokeDashoffset = len;
    }
  }

  // wire hover (and focus for keyboard)
  labels.forEach(lab=>{
    const id = lab.dataset.id;
    lab.tabIndex = 0;
    lab.addEventListener('mouseenter', ()=>activate(id,true));
    lab.addEventListener('mouseleave', ()=>activate(id,false));
    lab.addEventListener('focus',      ()=>activate(id,true));
    lab.addEventListener('blur',       ()=>activate(id,false));
  });

  // build, then layout-on-load and resize
  buildLines();
  // layout after fonts settle
  if(document.fonts && document.fonts.ready){
    document.fonts.ready.then(refreshAll);
  }
  window.addEventListener('load', refreshAll);
  window.addEventListener('resize', refreshAll);
  // initial pass
  requestAnimationFrame(refreshAll);
})();